/**
 * Class used to contain environment variables with values that depend on the environment.
 */
export class Environment {
    [key: string]: string | undefined;
}
